export default function ComparisonSection() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-secondary-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-foreground-800 bg-background-50 rounded-full">
            Comparison
          </span>
        </div>

        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 tracking-tight leading-tight max-w-2xl">
          ItaobuySpreadsheet vs Other Platforms
        </h2>

        <div className="mt-12 overflow-x-auto">
          <table className="w-full min-w-[640px] border-collapse">
            <thead>
              <tr className="border-b border-background-300/60">
                <th className="text-left py-4 px-4 text-sm font-semibold text-foreground-800">Platform</th>
                <th className="text-center py-4 px-4 text-sm font-semibold text-foreground-800">Ease of Use</th>
                <th className="text-center py-4 px-4 text-sm font-semibold text-foreground-800">Price</th>
                <th className="text-center py-4 px-4 text-sm font-semibold text-foreground-800">Update Speed</th>
                <th className="text-center py-4 px-4 text-sm font-semibold text-foreground-800">Beginner Friendly</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-200/70 bg-primary-50/30">
                <td className="py-5 px-4">
                  <span className="text-sm font-bold text-primary-700">ItaobuySpreadsheet</span>
                </td>
                <td className="py-5 px-4 text-center">
                  <span className="text-primary-600 text-sm">★★★★★</span>
                </td>
                <td className="py-5 px-4 text-center">
                  <span className="inline-block px-3 py-1 text-xs font-semibold bg-primary-100 text-primary-700 rounded-full">Low</span>
                </td>
                <td className="py-5 px-4 text-center">
                  <span className="inline-block px-3 py-1 text-xs font-semibold bg-primary-100 text-primary-700 rounded-full">Fast</span>
                </td>
                <td className="py-5 px-4 text-center">
                  <span className="inline-block px-3 py-1 text-xs font-semibold bg-primary-100 text-primary-700 rounded-full">Yes</span>
                </td>
              </tr>
              <tr className="border-b border-background-200/70">
                <td className="py-5 px-4">
                  <span className="text-sm text-foreground-700">Traditional Agents</span>
                </td>
                <td className="py-5 px-4 text-center">
                  <span className="text-foreground-400 text-sm">★★★☆☆</span>
                </td>
                <td className="py-5 px-4 text-center">
                  <span className="inline-block px-3 py-1 text-xs font-medium bg-foreground-100 text-foreground-600 rounded-full">Medium</span>
                </td>
                <td className="py-5 px-4 text-center">
                  <span className="inline-block px-3 py-1 text-xs font-medium bg-foreground-100 text-foreground-600 rounded-full">Slow</span>
                </td>
                <td className="py-5 px-4 text-center">
                  <span className="inline-block px-3 py-1 text-xs font-medium bg-foreground-100 text-foreground-600 rounded-full">No</span>
                </td>
              </tr>
              <tr className="border-b border-background-200/70">
                <td className="py-5 px-4">
                  <span className="text-sm text-foreground-700">Manual Lists</span>
                </td>
                <td className="py-5 px-4 text-center">
                  <span className="text-foreground-400 text-sm">★★☆☆☆</span>
                </td>
                <td className="py-5 px-4 text-center">
                  <span className="inline-block px-3 py-1 text-xs font-medium bg-foreground-100 text-foreground-600 rounded-full">Low</span>
                </td>
                <td className="py-5 px-4 text-center">
                  <span className="inline-block px-3 py-1 text-xs font-medium bg-foreground-100 text-foreground-600 rounded-full">Slow</span>
                </td>
                <td className="py-5 px-4 text-center">
                  <span className="inline-block px-3 py-1 text-xs font-medium bg-foreground-100 text-foreground-600 rounded-full">No</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="mt-8 text-sm text-foreground-600 leading-relaxed max-w-3xl">
          <strong className="text-foreground-900">ItaobuySpreadsheet</strong> stands out because it combines structured data, simplified navigation, and curated product listings, making it significantly easier for beginners compared to traditional agent-based shopping systems. The organized spreadsheet format provides transparency that manual lists simply cannot match.
        </p>
      </div>
    </section>
  );
}